import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles/globals.css';
import { installChunkReloadGuard } from '@/lib/appUpdate';

// Before the router mounts: a deploy deletes the old hashed chunks, so a stale tab's first
// lazy route load after one fails — this turns that into a single reload instead of a
// broken screen. PROD-gated internally.
installChunkReloadGuard();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);

// CSC-295 — register the Web Push service worker. Registration alone doesn't
// prompt the user for notification permission; the SW just sits dormant until
// the user opts in via DesktopPushToggle or the onboarding banner. Failures are
// non-fatal: a registration error means push doesn't work for this user, but
// the rest of the app is unaffected.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((err) => {
      console.warn('Service worker registration failed:', err);
    });
  });
}
